// removed by extract-text-webpack-plugin
module.exports = {"Radish":"#C20026","inputError":"G76f4fb G19bca4"};